import React from "react";

export default function Background () {
    return (
        <div className="fone">
            <img className="back-img houses" src='../../../images/auth/house1.png' alt='background'/>
        </div>
    )
}